import React from 'react';
import { Button, Form } from 'antd';
import TextInput from '../inputs/TextInput';
import SelectInput from '../inputs/SelectInput';
import PasswordInput from '../inputs/PasswordInput';
import useTranslation from '../../hooks/translation/useTranslation';

function LegalCustomerForm({
  form, options, loading, onFinish,
}) {
  const { trans } = useTranslation();
  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onFinish}
      onValuesChange={(changedValues) => {
        form.setFields(Object.keys(changedValues).map((key) => ({
          name: key,
          errors: [],
        })));
      }}
    >
      <TextInput
        label={`${trans('organization_name')}*`}
        name="organization_name"
      />
      <TextInput
        label={`${trans('identification_number')}*`}
        name="identification_number"
      />
      <TextInput
        label={`${trans('bank_account_number')}*`}
        name="bank_account_number"
      />
      <TextInput
        label={`${trans('legal_address')}*`}
        name="legal_address"
      />
      <SelectInput
        name="organization_type_id"
        label={`${trans('organization_type')}*`}
        options={options?.organization_types}
        labelName="name_ka"
        valueName="id"
      />
      <SelectInput
        name="country"
        label={`${trans('country')}*`}
        options={options?.countries}
        labelName="name_ka"
        valueName="id"
      />
      <TextInput
        label={`${trans('phone_number')}*`}
        name="phone_number"
      />
      <TextInput
        label={`${trans('email')}*`}
        name="email"
      />
      <PasswordInput
        label={`${trans('password')}*`}
        name="password"
      />
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {trans('submit')}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default LegalCustomerForm;
